/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to update a subscription
 * @export
 * @interface UpdateSubscriptionRequest
 */
export interface UpdateSubscriptionRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateSubscriptionRequest
     */
    tierCode?: UpdateSubscriptionRequestTierCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubscriptionRequest
     */
    status?: UpdateSubscriptionRequestStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateSubscriptionRequest
     */
    stripePaymentMethodId?: string;
}


/**
 * @export
 */
export const UpdateSubscriptionRequestTierCodeEnum = {
    Free: 'free',
    Starter: 'starter',
    Pro: 'pro',
    Expert: 'expert'
} as const;
export type UpdateSubscriptionRequestTierCodeEnum = typeof UpdateSubscriptionRequestTierCodeEnum[keyof typeof UpdateSubscriptionRequestTierCodeEnum];

/**
 * @export
 */
export const UpdateSubscriptionRequestStatusEnum = {
    Active: 'active',
    PastDue: 'past_due',
    Canceled: 'canceled'
} as const;
export type UpdateSubscriptionRequestStatusEnum = typeof UpdateSubscriptionRequestStatusEnum[keyof typeof UpdateSubscriptionRequestStatusEnum];


/**
 * Check if a given object implements the UpdateSubscriptionRequest interface.
 */
export function instanceOfUpdateSubscriptionRequest(value: object): value is UpdateSubscriptionRequest {
    return true;
}

export function UpdateSubscriptionRequestFromJSON(json: any): UpdateSubscriptionRequest {
    return UpdateSubscriptionRequestFromJSONTyped(json, false);
}

export function UpdateSubscriptionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSubscriptionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tierCode': json['tierCode'] == null ? undefined : json['tierCode'],
        'status': json['status'] == null ? undefined : json['status'],
        'stripePaymentMethodId': json['stripePaymentMethodId'] == null ? undefined : json['stripePaymentMethodId'],
    };
}

export function UpdateSubscriptionRequestToJSON(json: any): UpdateSubscriptionRequest {
    return UpdateSubscriptionRequestToJSONTyped(json, false);
}

export function UpdateSubscriptionRequestToJSONTyped(value?: UpdateSubscriptionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tierCode': value['tierCode'],
        'status': value['status'],
        'stripePaymentMethodId': value['stripePaymentMethodId'],
    };
}

